function extractNodeIDs(template: string): string[] {
  const nodeIDSet = new Set<string>();
  const jpRegex = /{{\s*jp\s*[`'"]([^`'"]+)[`'"]\s*}}/g;
  
  let match;
  while ((match = jpRegex.exec(template)) !== null) {
    const [, jpArg] = match;
    const parts = jpArg.split(':').map(part => part.trim());
    
    // If there's a valid node ID and data path
    if (parts.length > 1 && parts[0]) {
      nodeIDSet.add(parts[0]);
    }
  }

  return Array.from(nodeIDSet);
}

function extractNodeID(template: string): { nodeId: string; dataPath: string } | null {
  const jpRegex = /{{\s*jp\s*[`'"]([^`'"]+)[`'"]\s*}}/g;

  let match;
  while ((match = jpRegex.exec(template)) !== null) {
    const [, jpArg] = match;
    const parts = jpArg.split(':').map(part => part.trim());
    
    // If there's a valid node ID and data path
    if (parts.length > 1 && parts[0] && parts[1]) {
      return { 
        nodeId: parts[0], 
        dataPath: parts[1] 
      };
    }
  }

  return null;
}

export { extractNodeIDs, extractNodeID };
